import axios from '../utils/axios';

import { GET_ACTIVITIES } from './types';

export const getContactActivities = id => async dispatch => {
  try {
    const res = await axios.get(`/api/activity/contactActivities/${id}`);
    dispatch({
      type: GET_ACTIVITIES,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getMyActivities = () => async dispatch => {
  try {
    const res = await axios.get('/api/activity/myAllActivities');
    dispatch({
      type: GET_ACTIVITIES,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/activity.js